import { IconFont, Image, noButtons } from '@byecode/ui'
import styled, { css } from 'styled-components'

export const Title = styled.div`
    padding: 0 56px;
    color: var(--color-black);
    font-size: 48px;
    font-style: normal;
    font-weight: 500;
    line-height: 56px;
    text-align: center;
`

export const Describe = styled.div`
    padding: 0 56px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    color: var(--color-gray-500);
    margin-top: 16px;
    text-align: center;
`

export const BlockContainer = styled.div`
    margin-top: 32px;
    padding: 0 56px 60px 56px;
    max-width: 100%;
    display: flex;
    align-items: stretch;
    gap: 20px;
    /* flex: 1; */
    overflow: auto hidden;
    ${noButtons('8px')}
    transition: all 0.3 ease-in-out;
`

export const Block = styled.div`
    flex-shrink: 0;
    border-radius: 26px;
    width: 356px;
    height: 830px;
    /* background: linear-gradient(180deg, #f2f4f7 0%, rgba(242, 244, 247, 0.08) 100%); */
`

export const BlockWrapper = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    padding: 40px 28px 28px 28px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    background-color: var(--color-white);
    border: 1px solid var(--color-gray-200);
    /* box-shadow: 0px 4px 12px 0px rgba(16, 24, 40, 0.1); */
    overflow: hidden;
    &[data-space-version='ADVANCED'] {
        border: 1px solid rgba(228, 231, 236, 1);
        background: linear-gradient(180deg, rgba(0, 10, 255, 0.1) 0%, rgba(85, 81, 255, 0) 34.13%);
    }
`
export const BlockContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
`

export const BlockTitle = styled.div`
    color: var(--color-gray-900);
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
`

export const BlockCurrentTag = styled.div`
    background-color: var(--color-gray-100);
    border-radius: 6px;
    padding: 3px 6px;
    line-height: 22px;
    font-size: 14px;
    color: var(--color-gray-500);
`

export const BlockDescribe = styled.div`
    height: 48px;
    color: var(--color-gray-600);
    font-size: 16px;
    font-style: normal;
    line-height: 24px;
`
export const BlockPrice = styled.div`
    display: flex;
    align-items: flex-end;
    height: 56px;
    gap: 8px;
    margin-bottom: 16px;
`
export const Icon = styled(IconFont)<{ isPoint?: boolean }>`
    font-size: 16px;
    cursor: ${({ isPoint }) => (isPoint ? 'pointer' : 'auto')};
`

export const InfoList = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    gap: 24px;
    font-size: var(--font-size-normal);

    > * {
        width: 100%;
        line-height: 22px;
    }
`

export const KindBlock = styled.div`
    margin-top: 16px;
    width: 100%;
`
